import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "lazyload",
  "data-script": "https://accounts.google.com/gsi/client"
}, null, -1)
const _hoisted_2 = ["data-script"]
const _hoisted_3 = ["data-script"]

import {
  getAppInfo,
} from 'utilities';
import {
  onMounted,
  ref,
} from 'vue';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import {
  vuePublicPath,
} from '@/configs/client.config.json';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyScript',
  setup(__props) {


const authStore = useStore.auth;

const shouldPrefetch = ref(false);

onMounted(() => {
  setTimeout(() => {
    shouldPrefetch.value = true;
  }, 5 * 1000);
});

function getWebpackChunk(chunk: string): string {
  const { IS_DEVELOPMENT } = getAppInfo();

  const hasPublicPath = !!vuePublicPath.trim();
  const origin = hasPublicPath ? vuePublicPath.trim() : window.location.origin;

  // NOTE: defined in `vue.config.js`
  const chunkHash = process.env.CHUNK_HASH;
  const chunkPostfix = IS_DEVELOPMENT ? '' : `.${chunkHash}`;

  return `${origin}/js/${chunk}${chunkPostfix}.js`;
}

const commonWebpackChunks = [
  'home',
  'privacy-policy',
  'refund-policy',
  'terms-of-service',
  'faq',
];

const loggedWebpackChunks = [
  'user-contact',
  'user-dashboard',
  'end-user-view',

  ...commonWebpackChunks,
];

const nonLoggedWebpackChunks = [
  'auth',

  ...commonWebpackChunks,
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (shouldPrefetch.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(authStore).user)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(loggedWebpackChunks, (chunk) => {
                return _createElementVNode("div", {
                  key: chunk,
                  class: "lazyload",
                  "data-script": getWebpackChunk(chunk)
                }, null, 8, _hoisted_2)
              }), 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(nonLoggedWebpackChunks, (chunk) => {
                return _createElementVNode("div", {
                  key: chunk,
                  class: "lazyload",
                  "data-script": getWebpackChunk(chunk)
                }, null, 8, _hoisted_3)
              }), 64))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})